module.exports = __webpack_public_path__ + "img/IMG-20200716-WA0014.c953c4cc.jpg";